<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div *ngIf="securityRequestsEnabled">
    <button mat-raised-button color="primary" (click)="requestRecoveryKeyAccess()" [disabled]="buttonDisabled">{{'RECOVERY_KEY_REQUEST_BUTTON' | translate}}</button>
    <div *ngIf="currentRequest?.status == Status.APPROVED; else deniedContainer">
        <span>{{'REQUEST_APPROVED' | translate}}</span>&nbsp;
        <span class="status-link" (click)="viewRecoveryKeyStatus(currentRequest.id)">{{'ACCEPT' | translate}}</span>
    </div>

    <ng-template #deniedContainer>
        <div *ngIf="currentRequest?.status == Status.DENIED; else pendingContainer" class="status-container">
            <span>{{'REQUEST_DENIED' | translate}}</span>&nbsp;
            <span class="status-link" (click)="viewRecoveryKeyStatus(currentRequest.id)">{{'VIEW' | translate}}</span>
        </div>
    </ng-template>

    <ng-template #pendingContainer>
        <div *ngIf="currentRequest?.status == Status.PENDING" class="status-container">
            <span>{{'RECOVERY_KEY_REQUEST_IN_PROGRESS' | translate}}</span>&nbsp;
            <span class="status-link" (click)="viewRecoveryKeyStatus(currentRequest.id)">{{'RECOVERY_KEY_REQUEST_VIEW_STATUS' | translate}}</span>
        </div>
    </ng-template>
</div>
